export default {
  build: 'mq-8c93df9',
  builtAt: '1793757860',
};
